import Vue from 'vue';
import Router from 'vue-router';
import PersonalView from './views/PersonalView.vue';
import CommunicationsView from './views/CommunicationsView.vue';
import AddressView from './views/AddressView.vue';
import PaymentView from './views/PaymentView.vue';
import PrivacyView from './views/PrivacyView.vue';
import OrdersView from './views/OrdersView.vue';
import OrdersDetailView from './views/OrdersDetailView.vue';
import FavoritesView from './views/FavoritesView.vue';
import DirectDepositView from './views/DirectDepositView.vue';

Vue.use(Router);

export default new Router({
    linkActiveClass: 'active',
    routes: [
        {
            path: '/personal',
            name: 'personal',
            props: true,
            component: PersonalView
        },
        {
            path: '/communications',
            name: 'communications',
            component: CommunicationsView
        },
        {
            path: '/address',
            name: 'address',
            component: AddressView
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: PrivacyView
        },
        {
            path: '/orders',
            name: 'orders',
            component: OrdersView
        },
        {
            path: '/orderDetail/:ordernumber',
            name: 'orderDetail',
            component: OrdersDetailView,
            props: true
        },
        {
            path: '/payment',
            name: 'payment',
            component: PaymentView
        },
        {
            path: '/direct-deposit',
            name: 'direct-deposit',
            component: DirectDepositView
        },
        {
            path: '/favorites',
            name: 'favorites',
            component: FavoritesView
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    }
});
